
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";


export const MaaMundeshwari=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Maa Mundeshwari Temple</h1>
           <p className="sub-heading">India’s Oldest Functional Temple and a Sacred Pilgrimage Destination</p>
         </div>
         <div className="description">
           

Nestled atop the Mundeshwari Hills in Kaimur district, Bihar, Maa Mundeshwari Temple is one of the oldest functional Hindu temples in India, dating back to the 4th century CE. Dedicated to Goddess Mundeshwari, a form of Shakti, this ancient shrine is a marvel of history, spirituality, and architectural brilliance. The temple is constructed in the Nagara style and features intricate carvings and inscriptions that reflect the artistry of the Gupta period. A unique aspect of the temple is its octagonal shape, which is rare in Hindu temple architecture. Devotees flock here to seek the blessings of Maa Mundeshwari, who is worshipped in the form of a deity and a sacred stone. The temple also houses a Shivling, along with idols of Lord Vishnu, Ganesha, and Surya, emphasizing its significance as a center of Shaivism and Shaktism.  

Beyond the temple, visitors can explore nearby attractions such as Kaimur Wildlife Sanctuary, a haven for nature lovers and wildlife enthusiasts, and the Rohtasgarh Fort, a historical site known for its medieval architecture and panoramic views. The scenic beauty of the Mundeshwari Hills adds to the divine aura of the place, making it a peaceful retreat for pilgrims and travelers alike. The temple is especially vibrant during Navratri, when grand celebrations, rituals, and fairs attract devotees from across the country. Whether you are a history buff, a spiritual seeker, or an explorer, a visit to Maa Mundeshwari Temple offers a journey through time, faith, and natural splendor, making it a must-visit destination in Bihar.

  </div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Maa Mundeshwari/2018033031-olwdew6npdnrep5tz5gdx1otmcbkvu7vyw2dil9vuy.jpg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>

           <div className="image-item">
             <img
                  src={require('../../../media/tourism/other/Maa Mundeshwari/2018033035-olwdew6npdnrep5tz5gdx1otmcbkvu7vyw2dil9vuy.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                  src={require('../../../media/tourism/other/Maa Mundeshwari/cq5dam.web_.2000.765-3_REF-1.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           
           
          
         </div>
   
         <BookSection />
       </div>
     );
};